module.exports = __webpack_public_path__ + "static/media/maingate.e19ec9c9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/maingate.jpeg
// module id = 531
// module chunks = 0